import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema, publishedAtSchema } from '@/core/components';

import { PublishedIn, citationPrestigeList } from './CitationTypes';

const citationIdentifiersSchema = z.object({
  wosId: z.string(),
  doi: z.string(),
  scopusId: z.string(),
});

export const citationSchema = z.object({
  title: z.string().min(1),
  publishedIn: z.nativeEnum(PublishedIn),
  citationPrestige: z.enum(citationPrestigeList),
  wosIndexes: z.array(identitySchema),
  wosCategories: z.array(identitySchema),
  noOfAuthors: z.number().min(1),
  identifiers: citationIdentifiersSchema,
  citationDate: publishedAtSchema,
  journal: identitySchema.nullable(),
  publisher: identitySchema.nullable(),
  authors: z.array(authorSchema),
});

export type CitationSchema = z.infer<typeof citationSchema>;

export const defaultCitationValues: DefaultValues<CitationSchema> = {
  title: '',
  publishedIn: PublishedIn.JOURNAL,
  identifiers: {
    wosId: '',
    doi: '',
    scopusId: '',
  },
  journal: {
    id: 0,
  },
  publisher: {
    id: 0,
  },
  noOfAuthors: 0,
  wosIndexes: [],
  wosCategories: [],
  authors: [],
};
